import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("benefits", {
    model: {
      defaults: {
        draggable: true,
        droppable: false,
        components: html`
          <section class="py-6 container mx-auto px-4 ">
            <h2 class="md:text-3xl text-xl font-semibold">
              Why Choose Super Kinetic Express
            </h2>
            <div class="grid md:grid-cols-2 gap-y-4 py-4 gap-x-20 items-center">
              <div class="space-y-2 px-4 py-2 rounded-lg shadow-lg">
                <h3 class="text-lg font-semibold">Timely Deliveries</h3>
                <p>
                  Streamlining delivery routes to ensure timely and safe
                  transportation for every shipment
                </p>
              </div>
              <div class="space-y-2 px-4 py-2 rounded-lg shadow-lg">
                <h3 class="text-lg font-semibold">Prompt COD Payments</h3>
                <p>
                  Streamlining delivery routes to ensure timely and safe
                  transportation for every shipment
                </p>
              </div>
              <div class="space-y-2 px-4 py-2 rounded-lg shadow-lg">
                <h3 class="text-lg font-semibold">Transparent Pricing</h3>
                <p>
                  Streamlining delivery routes to ensure timely and safe
                  transportation for every shipment
                </p>
              </div>
              <div class="space-y-2 px-4 py-2 rounded-lg shadow-lg">
                <h3 class="text-lg font-semibold">Seamless API Integration</h3>
                <p>
                  Streamlining delivery routes to ensure timely and safe
                  transportation for every shipment
                </p>
              </div>
            </div>
          </section>
        `,
        // traits: [
        //   {
        //     type: "text",
        //     name: "icon",
        //     label: "Icon",
        //     changeProp: true,
        //   },
        //   {
        //     type: "text",
        //     name: "title",
        //     label: "Title",
        //     changeProp: true,
        //   },
        // ],
      },
    },
  });
};
